import { BrowserRouter,  Redirect   } from 'react-router-dom'
import React, {useEffect,useState} from "react";
import { EmptyLayout, LayoutRoute, MainLayout } from 'components/Layout';
const PrivateRoutes = () => {
    let auth = {'token':false}
    return(
        localStorage.getItem('AuthUser') === 'true' ? <BrowserRouter/> : <Redirect to="/"/>
    )
}


export default PrivateRoutes